import React from 'react';
import { FiBook, FiUsers } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

import { ModuleCard } from '@design-system/components/molecules/ModuleCard';
import { TopBar } from '@design-system/components/organisms/TopBar';

export const ModulesPage: React.FC = () => {
  const navigate = useNavigate();

  const handleOnboardingClick = () => {
    void navigate('/onboarding');
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      <TopBar />

      <main className="max-w-screen-2xl mx-auto px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-purple-600 mb-4">Módulos</h1>
          <p className="text-lg text-neutral-600">
            Escolha qual modulo do painel gerencial você deseja acessar:
          </p>
        </div>

        {/* Module Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <ModuleCard
            icon={<FiBook className="w-8 h-8" />}
            title="Onboarding"
            description="Analise, aprove ou reprove contas que estão em fase de cadastro e aguardando validação."
            onClick={handleOnboardingClick}
          />
          <ModuleCard
            icon={<FiUsers className="w-8 h-8" />}
            title="Gestão de acessos"
            description="Controle permissões e níveis de visibilidade para cada perfil de usuário."
            disabled
          />
        </div>
      </main>
    </div>
  );
};
